import React, { useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// banner image
// import page_1_elsa from "../../_asset/image/banner2/elsa.png"
// import frake from "../../_asset/image/banner2/frake.png"
// import frakefrake from "../../_asset/image/banner2/frakefrake.png"
// import bg_mountain from "../../_asset/image/banner2/bg_mountain.png"
import adbannerImage from "../../_asset/image/banner2/bannersexyae.png"

// Main hero banner — slot con los tres puntitos del swiper
import heroBannerImage from "../../_asset/image/banner2/bannerforgift.png"

import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from '../../apps/_root';
import { PageModalContext } from '../../apps/providers';
import { sexyVendor } from '../../data/gameData_casino';

export default function Banner() {
    return (
        <div className={'banner'}>
            <AdBannerLayout />
            <div className='ad-animation'>
                <BannerImages />
                <BannerSwiper />
            </div>
        </div>
    );
}

function AdBannerLayout() {
    const { UserAuthCheck } = useContext(UserContext)
    const { SetMenuType, SetVendor, SetPageName, SetPageModalShow } = useContext(PageModalContext)

    return (
        <div className='ad-banner --pointer'
            onClick={e =>
                UserAuthCheck(() => {
                    if (sexyVendor) {
                        SetMenuType('vendor')
                        SetPageName(sexyVendor.name)
                        SetVendor(sexyVendor.vendor)
                        SetPageModalShow(true)
                    }
                })
            }
        >
            <img src={adbannerImage} alt="" />
        </div>
    )
}
function BannerImages() {
    return (
        <div className={'banner-image'}>
            {/* Main hero background — bannerforgift.png
                El swiper de texto flota encima (lado izquierdo).
                La ilustración del lado derecho queda visible. */}
            <div className="hero-bg">
                <img src={heroBannerImage} alt="" />
            </div>
        </div>
    )
}

function BannerSwiper() {
    return (
        <div className={'banner-swiper-layout'}>
            <Swiper
                className={'banner-swiper'}
                direction={'vertical'}
                slidesPerView={1}
                loop={true}
                loopedSlides={1}

                speed={600}
                autoplay={{
                    delay: 5000
                }}
                pagination={{
                    clickable: true,
                    el: ".custom-pagination"
                }}
                navigation={{
                    enabled: true,
                    nextEl: ".swiper-arrow-next",
                    prevEl: ".swiper-arrow-prev",
                }}
                modules={[Autoplay, Pagination, Navigation]}
            >

                <SwiperSlide>
                    <div className={'banner-text-layout'}>
                        <div className={'inner'}>
                            <p className={'--color-beige'}>라이브 카지노 슬롯머신</p>
                            <p>해외정식 100% 정품 라이센스</p>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={'banner-text-layout'}>
                        <div className={'inner'}>
                            <p className={'--color-beige'}>실전과 같은 짜릿함!</p>
                            <p>라이브 카지노</p>
                            <p className={'--color-yellow'}>파텍 필립 카지노</p>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={'banner-text-layout'}>
                        <div className={'inner'}>
                            <p className={'--color-beige'}>국내 최대규모 파텍 필립 카지노!</p>
                            <p>슬롯당첨금액 최대 <b>1억!</b></p>
                            <p><b>잭팟</b>의 주인공이 되세요!</p>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
            <div className={'swiper-custom-navigation'}>
                <div className={'swiper-arrow-prev'}>
                    <FontAwesomeIcon icon={faChevronUp} />
                </div>
                <div className={'custom-pagination'}></div>
                <div className={'swiper-arrow-next'}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>
            </div>
        </div>
    )
}
